import { useMemo, type FC } from "react";

import { TActionHeroCtas } from "@/ui/components/sections/hero/ActionHero";
import { Grid } from "@/ui/components/layout/Grid";
import { Column, TColumSpansProp } from "@/ui/components/layout/Column";
import { Button } from "@/ui/components/primitives";

type TActionHeroCtasProps = {
  ctas?: TActionHeroCtas;
};

export const ActionHeroCtas: FC<TActionHeroCtasProps> = ({ ctas }) => {

  const columnSpans = useMemo((): TColumSpansProp => (
    (ctas?.length || 1) > 1 ? { default: "6", xl: "6" } : { default: "12", xl: "6" }
  ), [ ctas ]);

  if (!ctas) { return <></>;}

  return (
    <Grid>
      { ctas.map((cta, index) => cta ? (
        <Column key={index} spans={columnSpans}>
          <Button {...cta} width="fill"/>
        </Column>
      ) : null) }
    </Grid>
  );
};

ActionHeroCtas.displayName = "ActionHeroCtas";
